// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"90fa3024","175":"ed25f7d6","233":"2f22cdf0","369":"e9bc54d9","777":"d85915b3","936":"1c4995d2"}[chunkId] + ".js";
};